// extracted by mini-css-extract-plugin
export default {"card":"AddComments_card__Ok6eb","comment":"AddComments_comment__-55av"};